// mui
import Container from '@mui/material/Container';
//
import { Helmet } from 'react-helmet-async';
// sections
import TraCuuAnPham from 'src/sections/tra-cuu-an-pham/tra-cuu-an-pham';

// ----------------------------------------------------------------------

export default function Page() {
  return (
    <>
      <Helmet>
        <title> Tra cứu ấn phẩm </title>
      </Helmet>

      <Container>
        <TraCuuAnPham />
      </Container>
    </>
  );
}
